import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Text from 'ol/style/Text';
import Point from 'ol/geom/Point';
import { readStringSeq } from './panelMapFeatureProps.js';

/** 흑백 RGB 위성·패널 타일 위에서 테두리 대비용 */
export const PANEL_MAP_HALO = {
  outer: 'rgba(255, 255, 255, 0.92)',
  outerSoft: 'rgba(255, 255, 255, 0.65)',
  innerDark: 'rgba(18, 22, 26, 0.85)'
};

/**
 * @param {Object} opts
 * @param {string} opts.stroke - 안쪽(실선) 색
 * @param {string} opts.fill - 면 채움
 * @param {number} [opts.strokeWidth]
 * @param {number} [opts.haloExtra] - 바깥 흰 링 두께(px)
 * @param {import('ol/style/Text').default} [opts.text]
 * @returns {import('ol/style/Style').default[]}
 */
export function createPanelPolygonHaloStyles({
  stroke,
  fill,
  strokeWidth = 2,
  haloExtra = 3,
  text
}) {
  const innerW = strokeWidth;
  const outerW = strokeWidth + haloExtra;
  const haloStroke = new Stroke({
    color: PANEL_MAP_HALO.outer,
    width: outerW,
    lineJoin: 'round',
    lineCap: 'round'
  });
  const lineStroke = new Stroke({
    color: stroke,
    width: innerW,
    lineJoin: 'round',
    lineCap: 'round'
  });

  const styles = [
    new Style({
      stroke: haloStroke,
      fill: new Fill({ color: fill })
    }),
    new Style({ stroke: lineStroke })
  ];

  if (text) {
    styles[1].setText(text);
  }
  return styles;
}

/**
 * @param {import('ol/style/Style').default|import('ol/style/Style').default[]} styleOrArray
 */
export function asPanelMapStyles(styleOrArray) {
  if (!styleOrArray) {
    return [];
  }
  return Array.isArray(styleOrArray) ? styleOrArray : [styleOrArray];
}

/**
 * @param {Object} opts
 * @param {number} opts.radius
 * @param {string} opts.fill
 * @param {string} opts.stroke
 * @param {number} [opts.strokeWidth]
 */
export function createPanelVertexHandleHaloStyles({
  radius,
  fill,
  stroke,
  strokeWidth = 2
}) {
  return [
    new Style({
      image: new Circle({
        radius: radius + 2,
        fill: new Fill({ color: PANEL_MAP_HALO.outer }),
        stroke: new Stroke({ color: PANEL_MAP_HALO.outerSoft, width: 2 })
      })
    }),
    new Style({
      image: new Circle({
        radius,
        fill: new Fill({ color: fill }),
        stroke: new Stroke({ color: stroke, width: strokeWidth })
      })
    })
  ];
}

export function createPanelMapFeatureLabelText(text) {
  return new Text({
    text,
    font: 'bold 11px sans-serif',
    fill: new Fill({ color: '#FFFFFF' }),
    stroke: new Stroke({ color: PANEL_MAP_HALO.innerDark, width: 4 }),
    overflow: true
  });
}

/**
 * String 라벨을 앵커 Module이 아닌 String 전체 Module extent 중심에 표시
 * @param {string} labelText
 * @param {(stringSeq: string) => [number, number]|null} getCentroidFn
 */
export function createPanelMapStringCentroidLabelStyle(labelText, getCentroidFn) {
  return new Style({
    geometry: feature => {
      const stringSeq = readStringSeq(feature);
      if (stringSeq == null) {
        return feature.getGeometry();
      }
      const center = getCentroidFn(stringSeq);
      return center ? new Point(center) : feature.getGeometry();
    },
    text: createPanelMapFeatureLabelText(labelText)
  });
}
